import { render, staticRenderFns } from "./ReferenceFileMenu.vue?vue&type=template&id=7f3694e3&scoped=true&"
import script from "./ReferenceFileMenu.vue?vue&type=script&lang=ts&"
export * from "./ReferenceFileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceFileMenu.vue?vue&type=style&index=0&id=7f3694e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3694e3",
  null
  
)

export default component.exports